var _path, _path2, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgArrowDownRed = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0008 15C11.7335 14.9989 11.4779 14.891 11.2908 14.7003L7.29079 10.7042C6.90307 10.3145 6.90307 9.68517 7.29079 9.29551C7.47856 9.10638 7.73416 9 8.00079 9C8.26743 9 8.52303 9.10638 8.71079 9.29551L12.0008 12.5823L15.2908 9.29551C15.4786 9.10638 15.7342 9 16.0008 9C16.2674 9 16.523 9.10638 16.7108 9.29551C17.0985 9.68517 17.0985 10.3145 16.7108 10.7042L12.7108 14.7003C12.5237 14.891 12.268 14.9989 12.0008 15Z",
    fill: "#EC0000"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3803_2067",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 7,
    y: 9,
    width: 11,
    height: 6
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0008 15C11.7335 14.9989 11.4779 14.891 11.2908 14.7003L7.29079 10.7042C6.90307 10.3145 6.90307 9.68517 7.29079 9.29551C7.47856 9.10638 7.73416 9 8.00079 9C8.26743 9 8.52303 9.10638 8.71079 9.29551L12.0008 12.5823L15.2908 9.29551C15.4786 9.10638 15.7342 9 16.0008 9C16.2674 9 16.523 9.10638 16.7108 9.29551C17.0985 9.68517 17.0985 10.3145 16.7108 10.7042L12.7108 14.7003C12.5237 14.891 12.268 14.9989 12.0008 15Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3803_2067)"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgArrowDownRed);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/arrow-down-red.cadadefa44995bacca30eae62aa439f9.svg";